<template>
   <div id = "hero">
       <no-logo-header class = "is-hidden-mobile" :data="header" />
       <normal-header class = "is-hidden-desktop" :data="mobileHeader" />
       <split-hero />
       <prize-hero />
       <div class = "stand">
           <h1 class = "titleStand">{{$t('stand.title')}}</h1>
           <p class = "textStand" v-html="$t('stand.text')"></p>
       </div>
       <ButtonStand></ButtonStand>
       <h1 class = "title">{{$t('testimonial.title')}}</h1>
       <TestimSlider :normalQuotes="true"/>
   </div>
</template>

<script>
import NoLogoHeader from '@/components/global-components/NoLogoHeader'
import NormalHeader from '@/components/global-components/NormalHeader'
import SplitHero from '@/components/heroes/SplitHero'
import PrizeHero from '@/components/heroes/PrizesHero'
import TestimSlider from '@/components/sliders/testimonial-slider/TestimSlider'
import ButtonStand from'@/components/registration-components/ButtonStandAndFunDay(FB-Event)'

export default {
    components: {
        SplitHero,
        NormalHeader,
        NoLogoHeader,
        TestimSlider,
        PrizeHero,
        ButtonStand
    },
    data() {
        return {
            header: {
                transparent: true
            },
            mobileHeader: {
                transparent: false
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.title {
    border-top: 5px solid $secondary-color;
    padding-top: 5px;
    font-size: 30px!important;
    padding-top: 20px;
}
.titleStand {
    font-size: 35px;
}
.textStand {
    font-size: 20px;
    margin-bottom: 0px;
    padding-top: 15px;
}
.stand {
    text-align: center;
    padding-right: 5%;
    padding-left: 5%;
    margin-top: 3%;
    margin-bottom: 4%;
}
</style>